import React from 'react'
import Icon from '@components/icon/icon.component'
import PropTypes from 'prop-types'
import { BLUE } from '@styles/colors'
import useStyles from './button.style'

const Button = (props) => {
  const {
    children,
    className,
    disabled,
    icon,
    isLoading,
    onClick,
    iconStyle,
    type
  } = props

  const loading = isLoading ? 'is-loading' : ''

  const classes = useStyles(props)

  return (
    <button
      className={`${className} ${loading} ${classes.button}`}
      disabled={disabled}
      onClick={onClick}
      style={{ backgroundColor: BLUE }}
      type={type}
    >
      {children}
      {icon && !isLoading && <Icon
        style={iconStyle}
        type={icon}
      />}
    </button>
  )
}

Button.defaultProps = {
  children: null,
  className: '',
  icon: '',
  isLoading: false,
  onClick: () => {},
  style: {},
  type: ''
}

Button.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  className: PropTypes.string,
  icon: PropTypes.string,
  isLoading: PropTypes.bool,
  onClick: PropTypes.func,
  style: PropTypes.object,
  type: PropTypes.string
}

export default Button
